import { useCallback } from "react";
import TermoService from "../../Data/Services/TermoService";
import { ITermoEffects } from "./Interfaces/ITermoEffects";

export type TermoEffectsType = () => ITermoEffects;

export const TermoEffects: TermoEffectsType = () => ({
  getTermo: useCallback(async (nome: string) => {
    try {
      const { data } = await TermoService.fetchTermo(nome);

      window.open(data, "_BLANK");
    } catch (err: any) {
    } finally {
    }
  }, []),
});
